"use client"

import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    CardActions,
    Grid,
    Chip,
    Avatar,
    Pagination,
    Container,
    Autocomplete,
    Stack,
    TextField,
    IconButton,
    FormControlLabel,
    Switch,
} from "@mui/material"
import { Person as PersonIcon, Work as WorkIcon, School as SchoolIcon, Info as InfoIcon, Close } from "@mui/icons-material"
import axios from "axios"
import useRequestIdGenerater from "customhooks"
import { useEffect, useState } from "react"
import AnimatedLoader from "reuseableTable/AnimatedLoader"
import NoAvailableData from "reuseableTable/NoAvailableData"
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp"
import MainCard from "ui-component/cards/MainCard"
import BecomeMentorComponent from "./BecomeMentorComponent"
import MentorDetails from "./MentorDetails"
import ClearIcon from '@mui/icons-material/Clear';
import { dispatch } from "store"
import { openSnackbar } from "store/slices/snackbar"

const MainMentorship = () => {
    const [pageData, setPageData] = useState([])
    const [pageCache, setPageCache] = useState({})
    const [alumniReponseData, setAlumniResponseData] = useState({})
    const [showBecomeMentor, setShowBecomeMentor] = useState(false)
    const [showMentorProfile, setShowMentorProfile] = useState(false)
    const [loadingMentorProfile, setLoadingMentorProfile] = useState(false)

    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(9)
    const [totalCount, setTotalCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)

    const [MentorResponseData, setMentorResponseData] = useState({})
    const [myMentorResponseData, setMyMentorResponseData] = useState([])


    const [showMyMentors, setShowMyMentors] = useState(false);
    const [mentorAreaResponse, setMentorAreaResponse] = useState([])

    const [selectedArea, setSelectedArea] = useState("");

    const RequestId = useRequestIdGenerater()
    const { rendomRequestId, generateTimeStamp } = useTimeStamp()

    const handleBecomeMentor = () => {
        setShowBecomeMentor(true)
    }
    const handleBackToMentors = () => {
        setShowBecomeMentor(false)
        fetchData()
    }
    const handleViewDetails = (mentorData) => {
        getMentorDetails(mentorData?.alumniMemberId)
        setShowMentorProfile(true)
    }
    const getAlumniDetails = async () => {
        try {
            const response = await axios.get(`/v1/alumni/info?userId=${localStorage.getItem("userId")}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })
            setAlumniResponseData(response?.data?.data)
            generateTimeStamp()
        } catch (error) {
            generateTimeStamp()
            console.error("Failed to fetch data:", error)
        }
    }
    const getMyMentorsList = async () => {
        setPage(1)
        try {
            const response = await axios.get(`/v1/mentorship/my-mentor`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })
            setMyMentorResponseData(response?.data?.data)
            generateTimeStamp()
        } catch (error) {
            generateTimeStamp()
            console.error("Failed to fetch data:", error)
        }
    }
    const getMentorAreaList = async () => {
        try {
            const response = await axios.get(`/v1/mentorship/mentor-area-list`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })
            const rawData = response?.data?.data || []
            const uniqueMap = new Map()
            rawData.forEach(item => {
                const normalized = item.trim().toLowerCase()
                if (!uniqueMap.has(normalized)) {
                    uniqueMap.set(normalized, item.trim())
                }
            })
            const uniqueAreas = Array.from(uniqueMap.values())
            setMentorAreaResponse(uniqueAreas)
            generateTimeStamp()
        } catch (error) {
            generateTimeStamp()
            console.error("Failed to fetch data:", error)
        }
    }

    const getMentorDetails = async (mentorAlumniId) => {
        setLoadingMentorProfile(true)
        try {
            const response = await axios.get(`/v1/mentorship/mentor-details?mentorAlumniId=${mentorAlumniId}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                    ),
                },
            })
            setMentorResponseData(response?.data?.data)
            setLoadingMentorProfile(false)
            generateTimeStamp()
        } catch (error) {
            generateTimeStamp()
            setLoadingMentorProfile(false)
            console.error("Failed to fetch data:", error)
        }
    }

    const fetchData = async (area = "", resetPage = false) => {
        setIsLoading(true);
        const currentPage = resetPage ? 0 : page - 1;

        try {
            const response = await axios.get(
                `/v1/mentorship/mentors?pageSize=${rowsPerPage}&pageNumber=${currentPage}&areaOffers=${area}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999) + rendomRequestId,
                        ),
                    },
                }
            );
            setPageData(response?.data?.data?.content);
            setTotalCount(response?.data?.data?.totalElements);
            setPageCache((prev) => ({
                ...prev,
                [currentPage]: response?.data?.data?.content,
            }));
            if (resetPage) {
                setPage(1);
            }
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setIsLoading(false);
            generateTimeStamp();
        }
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value)
        setPage(1)
    }
    const handleRemoveMentor = (mentorAlumniId) => {
        axios
            .delete(
                `/v1/mentorship/remove-mentor?mentorId=${mentorAlumniId}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem("serviceToken")}`,
                        "Content-Type": "application/json",
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999 + rendomRequestId),
                        ),
                    },
                },
            )

            .then((value) => {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: value.data.Msg || "Removed Successfully!",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    }),
                )
                getMyMentorsList()
                generateTimeStamp()
            })
            .catch((error) => {
                // setIsSubmitting(false)
                generateTimeStamp()

                const message = error.response?.data?.Msg || (error.response?.status === 404 ? "Service not found" : "Something went wrong")
                const color = error.response?.status === 404 ? "error" : "error"

                dispatch(
                    openSnackbar({
                        open: true,
                        message: message,
                        variant: "alert",
                        alert: {
                            color: color,
                        },
                        close: false,
                    }),
                )
            })
    }




    useEffect(() => {
        const cacheKey = page - 1;
        if (pageCache[cacheKey]) {
            setPageData(pageCache[cacheKey]);
        } else {
            fetchData(selectedArea);
        }
    }, [page, rowsPerPage, selectedArea]);


    //     useEffect(() => {
    //     setPageCache({});
    //     fetchData(selectedArea, true);
    // }, [selectedArea]);


    useEffect(() => {
        getMentorAreaList()
        getAlumniDetails()
    }, [])

    if (showBecomeMentor) {
        return (
            <MainCard>
                <BecomeMentorComponent onBack={handleBackToMentors} alumniData={alumniReponseData} getAlumniDetails={getAlumniDetails} />
            </MainCard>
        )
    }

    const shouldShowBecomeMentorButton = pageData?.length === 0 && !isLoading && alumniReponseData?.mentor === false
    const totalPages = Math.ceil(totalCount / rowsPerPage)

    return (
        <MainCard>

            <>
                {showMentorProfile && (
                    <MentorDetails
                        showMentorProfile={showMentorProfile}
                        setShowMentorProfile={setShowMentorProfile}
                        mentorData={MentorResponseData}
                        setMentorResponseData={setMentorResponseData}
                        getMentorDetails={getMentorDetails}
                        loadingMentorProfile={loadingMentorProfile}
                        currentUserId={localStorage.getItem("userId")}
                    />
                )}

                <Container maxWidth="xl" sx={{ py: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 4,
                            flexWrap: "wrap",
                            gap: 2,
                        }}
                    >
                        <Box>

                            <>
                                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
                                    Find Your Mentor
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    Connect with experienced professionals to guide your career journey
                                </Typography>
                            </>

                        </Box>
                        {alumniReponseData?.mentor ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    getMentorDetails(alumniReponseData?.id)
                                    setShowMentorProfile(true)
                                }}
                                size="large"
                                sx={{
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 3,
                                    bgcolor: "#028943",
                                    "&:hover": {
                                        bgcolor: "#026d35",
                                    },
                                }}
                            >
                                Mentorship Panel
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleBecomeMentor}
                                size="large"
                                sx={{
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 3,
                                    bgcolor: "#028943",
                                    "&:hover": {
                                        bgcolor: "#026d35",
                                    },
                                }}
                            >
                                Become a Mentor
                            </Button>
                        )}
                    </Box>


                    <>
                        <Grid
                            container
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Grid item md={4} lg={4} xs={12}>
                                {!showMyMentors && (
                                    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
                                        <Autocomplete
                                            fullWidth
                                            options={mentorAreaResponse || []}
                                            value={selectedArea || null}
                                            onChange={(event, newValue) => {
                                                setSelectedArea(newValue || "")
                                                fetchData(newValue || "", true)
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Filter by Area" placeholder="Select Area" />
                                            )}
                                            clearOnEscape
                                        />
                                        {/* {selectedArea && (
                                            <IconButton
                                                onClick={() => {
                                                    setSelectedArea("")
                                                    fetchData("", true)
                                                }}
                                                color="secondary"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        )} */}
                                    </Stack>
                                )}
                            </Grid>
                            <Grid item md={3} lg={3} xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={showMyMentors}
                                            onChange={(e) => {
                                                const checked = e.target.checked
                                                setShowMyMentors(checked)
                                                if (checked) {
                                                    getMyMentorsList()
                                                } else {
                                                    fetchData(selectedArea, true)
                                                }
                                            }}
                                            sx={{
                                                "& .MuiSwitch-switchBase.Mui-checked": {
                                                    color: "#028943",
                                                },
                                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                    backgroundColor: "#028943",
                                                },
                                            }}
                                        />
                                    }
                                    label="Show My Mentors"
                                />
                            </Grid>
                        </Grid>
                    </>


                    {isLoading ? (
                        <AnimatedLoader />
                    ) : (
                        <>
                            <Grid container spacing={3} sx={{ mb: 4 }}>
                                {(showMyMentors ? myMentorResponseData : pageData).map((mentor, index) => (
                                    <Grid item xs={12} sm={6} md={3} key={mentor?.alumniMemberId || index}>
                                        <Card
                                            sx={{
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                transition: "all 0.3s ease-in-out",
                                                "&:hover": {
                                                    transform: "translateY(-4px)",
                                                    boxShadow: 6,
                                                },
                                                borderRadius: 2,
                                                border: "1px solid gray",
                                                // borderColor: "divider",
                                            }}
                                        >
                                            <CardContent sx={{ flexGrow: 1, p: 3 }}>
                                                {/* Header with Avatar and Name */}
                                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                                    <Avatar
                                                        alt={mentor?.alumniMemberMini?.name}
                                                        src={
                                                            mentor?.alumniMemberMini?.avatar?.data
                                                                ? `data:image/*;base64,${mentor.alumniMemberMini.avatar.data}`
                                                                : undefined
                                                        }
                                                        sx={{
                                                            width: 56,
                                                            height: 56,
                                                            mr: 2,
                                                            bgcolor: "#028943",
                                                            fontSize: "1.2rem",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {mentor?.alumniMemberMini?.name
                                                            ?.split(" ")
                                                            .map((n) => n[0])
                                                            .join("") || "AM"}
                                                    </Avatar>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <Typography
                                                            variant="h6"
                                                            component="h3"
                                                            sx={{
                                                                fontWeight: 600,
                                                                lineHeight: 1.2,
                                                                mb: 0.5,
                                                            }}
                                                        >
                                                            {mentor?.alumniMemberMini?.name || "Anonymous Mentor"}
                                                        </Typography>
                                                        <Chip
                                                            label={mentor?.alumniMemberMini?.batchTag || "Alumni"}
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{
                                                                borderColor: "#028943",
                                                                color: "#028943",
                                                                fontSize: "0.75rem",
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>

                                                {/* Career Status */}
                                                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                                    <WorkIcon sx={{ color: "text.secondary", mr: 1, fontSize: 20 }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Career:</strong> {mentor?.alumniMemberMini?.careerStatus || "Not specified"}
                                                    </Typography>
                                                </Box>

                                                {/* Areas of Interest */}
                                                <Box sx={{ mb: 2 }}>
                                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                                        Areas of Expertise:
                                                    </Typography>
                                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                        {mentor?.areaOffers?.length > 0 ? (
                                                            <>
                                                                {mentor.areaOffers.slice(0, 3).map((area, idx) => (
                                                                    <Chip
                                                                        key={idx}
                                                                        label={area}
                                                                        size="small"
                                                                        sx={{
                                                                            bgcolor: "#e8f5e8",
                                                                            color: "#028943",
                                                                            fontSize: "0.75rem",
                                                                            "&:hover": {
                                                                                bgcolor: "#d4f0d4",
                                                                            },
                                                                        }}
                                                                    />
                                                                ))}
                                                                {mentor?.areaOffers?.length > 3 && (
                                                                    <Chip
                                                                        label={`+${mentor.areaOffers.length - 3} more`}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        sx={{
                                                                            fontSize: "0.75rem",
                                                                            borderColor: "#ccc",
                                                                            color: "text.secondary",
                                                                        }}
                                                                    />
                                                                )}
                                                            </>
                                                        ) : (
                                                            <Typography variant="caption" color="text.disabled">
                                                                No areas specified
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>

                                                {/* Mentorship Info */}
                                                <Box sx={{ mb: 2 }}>
                                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
                                                        About Mentorship:
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.primary"
                                                        sx={{
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 3,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                            lineHeight: 1.4,
                                                        }}
                                                    >
                                                        {mentor?.mentorshipInfo || "No additional information provided."}
                                                    </Typography>
                                                </Box>
                                            </CardContent>

                                            <CardActions sx={{ p: 3, pt: 0, gap: 1 }}>
                                                {showMyMentors && (
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => handleRemoveMentor(mentor?.id)}
                                                        startIcon={<Close />}
                                                        sx={{
                                                            borderColor: "#f44336",
                                                            color: "#f44336",
                                                            "&:hover": {
                                                                bgcolor: "#ffebee",
                                                                borderColor: "#d32f2f",
                                                            },
                                                        }}
                                                    >
                                                        Remove
                                                    </Button>
                                                )}
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => handleViewDetails(mentor)}
                                                    startIcon={<InfoIcon />}
                                                    sx={{
                                                        bgcolor: "#028943",
                                                        flexGrow: 1,
                                                        borderRadius: 2,
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                        "&:hover": {
                                                            bgcolor: "#026d35",
                                                        },
                                                    }}
                                                >
                                                    Details
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                            {!showMyMentors && totalPages > 0 && (
                                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                                    <Pagination
                                        count={totalPages}
                                        page={page}
                                        onChange={handleChangePage}
                                        color="primary"
                                        size="large"
                                        showFirstButton
                                        showLastButton
                                        sx={{
                                            "& .MuiPaginationItem-root": {
                                                borderRadius: 2,
                                            },
                                            "& .MuiPaginationItem-root.Mui-selected": {
                                                bgcolor: "#028943",
                                                "&:hover": {
                                                    bgcolor: "#026d35",
                                                },
                                            },
                                        }}
                                    />
                                </Box>
                            )}
                        </>
                    )}
                </Container>
                {shouldShowBecomeMentorButton && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "400px",
                            gap: 3,
                            textAlign: "center",
                            px: 3,
                        }}
                    >
                        <PersonIcon sx={{ fontSize: 80, color: "text.disabled" }} />
                        <Box>
                            <Typography variant="h5" color="text.primary" gutterBottom sx={{ fontWeight: 600 }}>
                                No Mentors Available
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: 400 }}>
                                Be the first to help others! Share your knowledge and experience as a mentor and make a difference in
                                someone's career journey.
                            </Typography>
                        </Box>
                        {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={handleBecomeMentor}
                            size="large"
                            startIcon={<SchoolIcon />}
                            sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                px: 4,
                                py: 1.5,
                                bgcolor: "#028943",
                                "&:hover": {
                                    bgcolor: "#026d35",
                                },
                            }}
                        >
                            Become a Mentor
                        </Button> */}
                    </Box>
                )}
            </>

        </MainCard >
    )
}

export default MainMentorship
